import * as Scorm2004Api from "./api2004";
import {AllScos2004Data} from "./api2004";
import {Manifest, ScoNavItem} from "../scorm/manifest";
import {ScormPluginBase} from "../scorm/plugin";
import {Manifest2004, ScoNavItem2004} from "./manifest2004";
import {NavigationRequest, Request, RequestCategory, SequencingProcess2004, STATUS_VALID} from "./sn";
import {initializeApiShared} from "./pluginshared";
import {NavActions} from "../scorm/sn";

export {UrlVarService} from "../url";


export class Scorm2004Plugin extends ScormPluginBase {
    public API_1484_11: Scorm2004Api.Scorm2004Api = null;
    public sequencing: SequencingProcess2004 = null;

    attemptSequencing(): string {
        if (this.nextScoAction) {
            this.events.preSequencing.dispatch("sequencing", [this.nextScoAction, this.nextScoTarget]);
            let seqOut = this.sequencing.do(new Request(RequestCategory.Navigation, this.nextScoAction, this.nextScoTarget));
            this.events.postSequencing.dispatch("sequencing", [this.nextScoAction, this.nextScoTarget], seqOut);
            return seqOut;
        }
        return "";
    }

    createManifestClass(): Manifest {
        let man: Manifest;
        if (this.mvc.lastError != "") {
            return null;
        }

        if (this.mvc.schemaVersionMain == "2004") {
            man = new Manifest2004();
        }
        else {
            throw new Error("Manifest is for an unsupported SCORM version: " + this.mvc.schemaVersionMain);
        }
        man.schemaVersionMain = this.mvc.schemaVersionMain;
        man.schemaVersionSub = this.mvc.schemaVersionSub;
        man.rawManifest = this.mvc.rawManifest;
        return man;
    }

    initializeApi(scoNav: ScoNavItem) {
        let i = this.scosData.scos[scoNav.identifier];
        initializeApiShared(i, scoNav, this.config);
        this.API_1484_11 = new Scorm2004Api.Scorm2004Api(scoNav.identifier,
            (<Scorm2004Api.Sco2004Data>this.scosData.scos[scoNav.identifier]), this.events, this.config,
            Object.keys(this.manifest.scosByIdentifiers),
            this.manifest.navigableScoPreOrderTraversal.map(x => x.identifier),
            scoNav as ScoNavItem2004);
        this.API_1484_11.addSaveCallback(this.storage.save, this.storage);
        (<any>window).API_1484_11 = this.API_1484_11;
        if (this.config.initializeScoAtOpen()) {
            this.API_1484_11.Initialize("");
        }
    }

    endPreviousSco() {
        // If there's anything already open, close it.
        // And don't re-end an already ended SCO.
        if (this.currentSco && this.API_1484_11 && !this.API_1484_11.sco.end) {
            this.API_1484_11.Terminate("");
        }
    }

    initializeScosData() {
        let i: number;
        // Now that we know the version, build the data structure that uses it.
        this.scosData = new Scorm2004Api.AllScos2004Data();
        for (i = 0; i < this.manifest.scoPreOrderTraversal.length; i++) {
            this.scosData.scos[this.manifest.scoPreOrderTraversal[i].identifier] = new Scorm2004Api.Sco2004Data();
        }
    }

    initializeSequencing() {
        this.sequencing = new SequencingProcess2004(this.manifest as Manifest2004, this.scosData as AllScos2004Data, this.events, this.config);

        // When attempting to return to last SCO on launch,
        // verify that the current SCO ID still exists in the version of the course that's trying to be loaded.
        // If it doesn't, we must fall through to a normal default launch.
        if (this.config.returnToLastActivityOnLaunch() && this.scosData.currentScoId && this.manifest.scosByIdentifiers[this.scosData.currentScoId]) {
            // To make SCORM 2004 sequencing do the right thing, we have to fake a Start first,
            // then we can attempt to navigate to the SCO we left off at.
            this.sequencing.suspendedActivityId = this.scosData.currentScoId;
            this.nextScoAction = NavActions.ResumeAll;
            this.nextScoTarget = "";
        }
        else if (this.config.autoLaunchFirstSco()) {
            this.nextScoAction = NavActions.Start;
            this.nextScoTarget = "";
        }

        if (this.nextScoAction) {
            this.attemptNavigate();
        }
    }

    navigate(type: string) {
        this.nextScoAction = null;
        this.nextScoTarget = "";
        if (type === "next") {
            this.nextScoAction = NavActions.Continue;
            this.nextScoTarget = "";
        }
        else if (type === "previous") {
            this.nextScoAction = NavActions.Previous;
            this.nextScoTarget = "";
        }
        else if (type === "repeat") {
            this.nextScoAction = NavActions.Choice;
            this.nextScoTarget = this.currentSco.identifier;
        }

        if (this.nextScoAction) {
            this.attemptNavigate();
        }
    }

    navigateByIdentifier(id: string) {
        this.nextScoAction = NavActions.Choice;
        this.nextScoTarget = id;
        this.attemptNavigate();
    }

    updateManifestSelectability() {
        if (this.sequencing) {
            let rf = this.sequencing.nb_2_1(new NavigationRequest(NavActions.Continue));
            let btn = (<HTMLButtonElement>document.getElementById("next"));
            btn.disabled = true;
            if (rf.status == STATUS_VALID) {
                rf = this.sequencing.sb_2_12(rf.seqReq);
                if (rf.status == STATUS_VALID) {
                    btn.disabled = false;
                }
            }

            rf = this.sequencing.nb_2_1(new NavigationRequest(NavActions.Previous));
            btn = (<HTMLButtonElement>document.getElementById("prev"));
            btn.disabled = true;
            if (rf.status == STATUS_VALID) {
                rf = this.sequencing.sb_2_12(rf.seqReq);
                if (rf.status == STATUS_VALID) {
                    btn.disabled = false;
                }
            }

            for (let i: number = 0; i < this.manifest.scoPreOrderTraversal.length; i++) {
                let scoNav = this.manifest.scoPreOrderTraversal[i] as ScoNavItem2004;
                if (this.sequencing.up_5(scoNav)) {
                    scoNav.isSelectable = false;
                }
                else {
                    scoNav.isSelectable = true;
                }
                this.toc.updateSelectability(scoNav);

                // TODO should we also do a deliverability check?
            }
        }
    }
}
